import React, { useState } from 'react';
import PropTypes from 'prop-types';
import plusIcon from 'assets/images/icons/plus.svg';
import searchIcon from 'assets/images/icons/search.svg';
import TextField from 'components/form-components/TextField';
import GuestUsersActions from './GuestUsersActions';
import FormButton from 'components/form-components/FormButton';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';

const GuestUsersListHeader = ({
  handleDebouncedFilter,
  selectedRows,
  actionsCallBack,
  openAddUserModal,
}) => {
  const [searchText, setSearchText] = useState('');

  return (
    <div className='my-3 d-flex gap-2 flex-wrap justify-content-between align-items-end'>
      <div className='d-flex gap-3'>
        <TextField
          value={searchText}
          name='search'
          handleChange={(_, value) => setSearchText(value)}
          placeholder={'field_search'}
          icon={searchIcon}
          debounceFunc={handleDebouncedFilter}
          shrink
        />

        <GuestUsersActions
          ids={selectedRows}
          isActionButton={false}
          actionsCallBack={actionsCallBack}
        />
      </div>
      {isPermissionAvailable(permissionKeys.employees_users_create) && (
        <div>
          <FormButton
            text='button_add_user'
            onClick={openAddUserModal}
            variant='green-2'
            icon={plusIcon}
          />
        </div>
      )}
    </div>
  );
};

GuestUsersListHeader.propTypes = {
  handleDebouncedFilter: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func,
  openAddUserModal: PropTypes.func.isRequired,
};

export default GuestUsersListHeader;
